import React from "react";
import "./Button.scss";
import { Link } from "react-router-dom";

export default function Button({
  to,
  text,
  variant = "primary" | "secondary" | "outline",
  iconLeft = null,
  iconRight = null,
  className = "",
  ...props
}) {
  return (
    <Link
      to={to}
      className={`button button__${variant} ${className}`}
      {...props}
    >
      {iconLeft && (
        <span className="button__icon button__icon_left">{iconLeft}</span>
      )}
      <span className="button__text">{text}</span>
      {iconRight && (
        <span className="button__icon button__icon_right">{iconRight}</span>
      )}
    </Link>
  );
}
